import { CurrentUserModel } from '@/__generated';

export interface AppCurrentUserModel extends CurrentUserModel {
  /**  */
  roleClaims?: string[];
  hasFaBookings?: boolean;
}
export enum APP_ROLE {
  Admin = 'Admin',
  Report = 'Report',
  Booking = 'Booking',
}

export const hasRoles = (roles: APP_ROLE[] | '*' | undefined, auth: AppCurrentUserModel | null) => {
  return roles === '*' || auth?.roleClaims?.some(x => roles?.includes(x as APP_ROLE));
};
class RoleService {
  isAdminOrReport = (roles: string[] | null | undefined) => {
    return roles?.some(r => [APP_ROLE.Admin, APP_ROLE.Report].includes(r as any));
  };
}
export default new RoleService();
